cb.define([], function () {

    var PM_pmc_groupbuyinglist_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var gridModel = viewmodel.getGridModel();
            //启用停用控制
            gridModel.on('afterSetDataSource', () => {
                const rows = gridModel.getRows();
                const actions = gridModel.getCache('actions');
                const actionsStates = [];
                rows.forEach(data => {
                    const actionState = {};
                    actions.forEach(action => {
                        if (action.cItemName == "btnDisAble") {

                            if (data.status == 0) {
                                actionState[action.cItemName] = {visible: false};
                            } else {
                                actionState[action.cItemName] = {visible: true};
                            }
                        } else if (action.cItemName == "btnEnAble") {
                            if (data.status == 0) {
                                actionState[action.cItemName] = {visible: true};
                            } else {
                                actionState[action.cItemName] = {visible: false};
                            }
                        } else {
                            actionState[action.cItemName] = {visible: true};
                        }
                    });
                    actionsStates.push(actionState);
                });
                gridModel.setActionsState(actionsStates);
            });
            //进行情况控制
            viewmodel.on('progress', (args) => {
                var row = viewmodel.getGridModel().getRowsByIndexes(args.params.index);
                var data = {
                    billtype: 'VoucherList',
                    billno: 'pmc_groupBuyingStatusView',
                    params: {
                        groupBuyingId: row[0].id
                    }
                };
                cb.loader.runCommandLine('bill', data, viewmodel, (vm) => {
                    vm.on('promotionabandon', function () {
                        vm.execute('close');
                    });

                    vm.on('close', function () {
                        viewmodel.communication({
                            type: 'modal',
                            payload: {
                                data: false
                            }
                        })
                    })
                    return true;
                })
            })
        }
    };
    try {
        module.exports = PM_pmc_groupbuyinglist_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_groupbuyinglist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_groupbuyinglist_VM.Extend.js